import { useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { IPromotionConditionDetail } from "interfaces";
import { endpointService } from "components/shared/services/endpointService";
import { EditPromotionConditionForm, EditPromotionCouponForm } from "components/shared/promotion/forms";

export const EditWPSPromotionCondition: React.FC = () => {
  const parse = useParse();
  const { params } = parse();

  const { data: conditionDetail } = useOne<IPromotionConditionDetail>({
    resource: endpointService.getPromotionEndPoint("getConditionDetail", {
      conditionId: params?.id,
    }),
    id: "",
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const conditionDetailData = conditionDetail?.data ?? null;

  return (
    <div className="wrapper p-4">
      <Breadcrumbs />
      {conditionDetailData ? (
        <EditPromotionConditionForm defaultConditionData={conditionDetailData} />
      ) : (
        <></>
      )}
    </div>
  );
};
